import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { deleteInvitedUser } from "@/redux/actions/usersActions";
import { Trash2 } from "lucide-react";
import React from "react";
import { useDispatch } from "react-redux";

const DeleteInvitedUser: React.FC<{ userId: number }> = ({ userId }) => {
  const dispatch: any = useDispatch();

  const handleDeleteInvite = async (userId: number) => {
    dispatch(deleteInvitedUser(userId));
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Trash2 />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to delete?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the
            account and remove the data from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => handleDeleteInvite(userId)}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteInvitedUser;
